<template>

<div class="subheading">

    <div class="subheading-text">{{ label }}</div>

</div>

</template>

<script>

export default {

	props: ['label']

}

</script>

<style scoped>

.subheading {
    margin: 20px 0px;
}

.subheading-text {
    font-size: 14px;
    font-weight: 400;
    color: #687589;
    background-color: #fff;
    z-index: 2;
    display: inline-block;
    width: 200px;
}

.subheading:before {
    position: absolute;
    content: '';
    display: block;
    left: 0px;
    top: 50%;
    margin-top: -1px;
    right: 0px;
    height: 2px;
    background-color: #eee;
    z-index: 1;
}

</style>
